import { ExpandMore } from '@mui/icons-material';
import KitchenIndentTable from '../../../../components/commonComponent/KitchenIndentTable';
import { IconPlus } from '../../../../icons/Icon';
import { formatCost } from '../../../../utils/format';
import styles from '../kitchenindentdetails.module.scss';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { addMog, fetchKitchenIndent, saveKitchenIndent } from '../../../../services/kitchenIndentProductionPlanSlice';

interface AccordionProps {
  openIndices: number[];
  handleToggle: (index: number) => void;
  dayPartIndex: number;
  dayPartMog: any;
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>
  kitchenSectionCode: string;
  isEditable: boolean;
  handleDeleteMog: (kitchensectioncode: string, daypartcode: string, mogcode: string) => void;
  mealCount: number | null;
  dishQty: number | null;
}

const Accordion: React.FC<AccordionProps> = ({ openIndices, handleToggle, dayPartIndex, dayPartMog, searchTerm, setSearchTerm, kitchenSectionCode, isEditable, handleDeleteMog, mealCount, dishQty }) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const [showAddMog, setShowAddMog] = useState<boolean>(false);
  const [editMogCode, setEditMogCode] = useState<string>("");
  const { params } = useSelector((state: any) => state.productionPlan);
  const showcostValue = localStorage.getItem('showcost');
  // Same value the Revised Qty box shows: revised quantity, else plan quantity
  const totalRevisedQty = (dayPartMog?.recipesmoglist ?? []).reduce(
    (sum: number, mog: any) => sum + Number(mog?.revisedquantity ?? mog?.planquantity ?? 0), 0);

  const handleAddMog = (mogcode: string) => {
    dispatch(addMog({
      menuDate: params?.menudate,
      kitchensectioncode: kitchenSectionCode,
      daypartcode: dayPartMog?.daypartcode,
      mogcode,
    })).unwrap().then((res: any) => {
      toast(res?.message, { type: "success" });
      setShowAddMog(prev => !prev);
      dispatch(fetchKitchenIndent({
        menudate: params?.menudate,
        daypartidlist: params?.indentdayparts
      }));
    }).catch((error) => {
      console.error(" add mog API error::", error)
    })
  }

  const handleSaveKitchenIndent = (mogdetails: object) => {
    dispatch(saveKitchenIndent({
      menudate: params?.menudate,
      kitchensectioncode: kitchenSectionCode,
      daypartcode: dayPartMog?.daypartcode,
      ...mogdetails
    })).unwrap().then(() => {
      setEditMogCode("");
      dispatch(fetchKitchenIndent({
        menudate: params?.menudate,
        daypartidlist: params?.indentdayparts
      }));
    }).catch((error) => {
      console.error(" add mog API error::", error)
    })
  }

  useEffect(() => {
    if (showAddMog) {
      setShowAddMog(false);
    }
    setEditMogCode("");
  }, [searchTerm]);

  return (
    <>
      <div className={`innrBox ${openIndices.includes(dayPartIndex) ? 'active' : ''}`}>
        <div className='flex align-items-center justify-content-between'>
          <button
            onClick={() => handleToggle(dayPartIndex)}
            className={`flex align-items-center dropDownButton wd-140 ${openIndices.includes(dayPartIndex) ? 'active' : ''
              }`}
          >
            <span>
              <ExpandMore />
            </span>{' '}
            {dayPartMog?.name}
          </button>
          <div className='flex align-items-center total-cost semi-bold'>
            {dishQty != null && <>
              <div><span>Total Req. Dish Qty (Kg)</span>: {formatCost(dishQty, 3)}</div>
              <span className={styles.divide}>|</span>
            </>}
            {mealCount != null && <>
              <div><span>Meal Count</span>: {mealCount}</div>
              <span className={styles.divide}>|</span>
            </>}
            <div><span>Total Revised Indent Qty (Kg)</span>: {formatCost(totalRevisedQty, 3)}</div>
            {showcostValue === 'true' && <>
              <span className={styles.divide}>|</span>
              <div><span>Total Indent Cost</span>: ₹ {formatCost(dayPartMog?.totalcost, 2)}</div>
            </>}
          </div>
          <div className='flex align-items-center add-mog'>
            {openIndices.includes(dayPartIndex) && isEditable && <button onClick={() => { if (!showAddMog) { setShowAddMog(true); setSearchTerm(""); } }}><span><IconPlus /></span> Add MOG</button>}
          </div>
        </div>
        {openIndices.includes(dayPartIndex) && (
          <div className='content'>
            {!!dayPartMog?.recipemissingdishes?.length && <div className='recipe-message'>
              <strong>Recipe Missing Dishes:</strong> {dayPartMog?.recipemissingdishes}
            </div>}
            <KitchenIndentTable
              dayPartMogList={dayPartMog?.recipesmoglist?.filter((mog: any) => mog?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase()) || mog?.aplname?.toLowerCase()?.includes(searchTerm?.toLowerCase()))}
              dayPartCode={dayPartMog?.daypartcode}
              kitchenSectionCode={kitchenSectionCode}
              isEditable={isEditable}
              showAddMog={showAddMog}
              setShowAddMog={setShowAddMog}
              editMogCode={editMogCode}
              setEditMogCode={setEditMogCode}
              handleDeleteMog={handleDeleteMog}
              handleSaveKitchenIndent={handleSaveKitchenIndent}
              handleAddMog={handleAddMog}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Accordion;
